<template>
  <div :style="styling">
    <label v-if="label">{{ label }}</label>
    <div class="input_text_field">
      <textarea
        ref="field"
        :style="inputStyling"
        :disabled="disabled"
        :placeholder="placeholder"
        autocomplete="off"
        data-lpignore="true"
        :value="modelValue"
        @input="update"
        @focus="onFocus"
        @blur="onBlur"
      />
    </div>
    <span v-if="error" class="errorMessage">{{ error }}</span>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue';

const props = defineProps([
  "error",
  "label",
  "modelValue",
  "details",
  "block",
  "placeholder",
  "height",
  "minHeight",
  "disabled",
  "autofocus",
  "width"
]);

const emit = defineEmits();

const field = ref(null);

const onFocus = () => emit("focus");
const onBlur = () => emit("blur");
const update = () => emit("update:modelValue", field.value.value);

const styling = computed(() => {
  let ob = {};
  if (props.block === "" || props.block === "true") ob.width = "100%";
  if (props.details === "" || props.details === "true") ob.minHeight = "80px";
  if (props.label && props.label.length > 0) ob.paddingTop = "0px";
  return ob;
});

const inputStyling = computed(() => {
  let ob = {};
  ob.resize = "vertical";
  ob.padding = "11.66px 19px";
  ob.border = "1.5px solid var(--shade4)";
  ob.borderRadius = "8px";
  ob.fontSize = "16px";
  ob.color = "var(--shade6)";
  ob.backgroundColor = "var(--shade3)";
  if (props.height) ob.height = props.height + 'px';
  if (props.minHeight) ob.minHeight = props.minHeight + 'px';
  if (props.width) ob.width = props.width + 'px';
  return ob;
});

onMounted(() => {
  if (props.autofocus === "") field.value.focus();
});

watch(() => props.modelValue, (newValue) => {
  if (newValue) field.value.setAttribute("value", newValue);
});
</script>

<style scoped>
.input_text_field {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
}

label {
  font-size: 16px;
  color: rgba(17, 24, 39, 1);
  margin-bottom: 4px;
}

.errorMessage {
  font-size: 14px;
  color: #df5151;
  margin-left: 8px;
}

textarea {
  width: 100%;
  box-sizing: border-box;
  font-family: Roboto;
  transition: all 0.3s ease;
}

textarea:hover {
  background-color: var(--shade2);
}

textarea:focus {
  background-color: var(--shade1) !important;
  font-weight: 600;
  color: var(--black);
  outline: none;
  border: 1.5px solid var(--primary) !important;
}

textarea:focus::placeholder {
  color: var(--shade5);
}

textarea::placeholder {
  color: var(--shade5);
}

textarea:disabled::placeholder {
  color: #000000;
}

textarea:disabled {
  background-color: #EAEAEA;
  color: #000000;
}
</style>
